export enum EntityTypes {
  Plan = 1,
  Job,
  Location,
  Service,
  PlanContiner,
  CommittedOrder
}
